export default "__VITE_ASSET__BTR9ww$L__"